
<div class="row">
    <div class="col col-12">
        <div class="detail-card">
            <div class="row no-gutters">
                <div class="col col-6">
                    <slot name="title"><h4 v-if="title">{{ title }}</h4></slot>
                    <slot name="description"><p v-if="description" class="overview_description">{{ description }}</p></slot>
                </div>
                <div class="col col-6">
                    <slot name="content"></slot>
                </div>
            </div>
        </div>
    </div>
</div>
